<div class="fb-card">
	@if (screen === FeedbackScreen.RATING) {
		<div class="fb-screen fb-active">
			<p class="fb-eyebrow">{{ badge }}</p>
			<p class="fb-title">{{ 'feedbackWidget.ratingQuestion' | translate }}</p>
			<div [attr.aria-label]="'feedbackWidget.selectRating' | translate" class="fb-stars">
				@for (i of stars; track i) {
					<button
						(click)="onStarClick(i)"
						(mouseenter)="onStarHover(i)"
						(mouseleave)="onStarLeave()"
						[attr.aria-label]="'feedbackWidget.starAriaLabel' | translate: { count: i }"
						[class.fb-selected]="i === selected"
						class="fb-star"
						type="button"
					>
						<svg aria-hidden="true" height="48" viewBox="0 0 52 52" width="48" xmlns="http://www.w3.org/2000/svg">
							<polygon
								[attr.fill]="starColor(i)"
								[attr.stroke]="starColor(i)"
								points="26,4 32,19 48,19 35,30 40,46 26,36 12,46 17,30 4,19 20,19"
								stroke-linejoin="round"
								stroke-width="1.5"
							/>
						</svg>
					</button>
				}
			</div>
			<p class="fb-label">{{ currentLabel }}</p>
		</div>
	}

	@if (screen === FeedbackScreen.THANKYOU) {
		<div class="fb-screen fb-active">
			<div class="fb-emoji">🙌</div>
			<p class="fb-title">{{ 'feedbackWidget.thankYouTitle' | translate }}</p>
			<p class="fb-subtitle">{{ 'feedbackWidget.shareOnGoogle' | translate }}</p>
			<ion-row>
				<ion-col>
					<ion-button (click)="goGoogle()" color="primary" expand="block">{{ 'feedbackWidget.yes' | translate }}</ion-button>
				</ion-col>
				<ion-col>
					<ion-button (click)="showDone()" color="secondary" expand="block">{{ 'feedbackWidget.no' | translate }}</ion-button>
				</ion-col>
			</ion-row>
		</div>
	}

	@if (screen === FeedbackScreen.LOW) {
		<div class="fb-screen fb-active">
			<div class="fb-emoji">😔</div>
			<p class="fb-title">{{ 'feedbackWidget.lowTitle' | translate }}</p>
			<p class="fb-copy">{{ 'feedbackWidget.lowMessage' | translate }}</p>
			<textarea
				[(ngModel)]="comment"
				[disabled]="submitting"
				[attr.placeholder]="'feedbackWidget.feedbackPlaceholder' | translate"
				class="fb-textarea"
			></textarea>
			<input
				[(ngModel)]="contact"
				[disabled]="submitting"
				[attr.placeholder]="'feedbackWidget.contactPlaceholder' | translate"
				class="fb-input"
				type="text"
				inputmode="text"
				autocomplete="off"
			/>
			@if (submitError) {
				<p class="fb-error">{{ submitError }}</p>
			}
			<ion-row>
				<ion-col>
					<ion-button (click)="submitLowFeedback()" [disabled]="submitting" color="primary" expand="block">
						{{ (submitting ? 'feedbackWidget.sending' : 'common.send') | translate }}
					</ion-button>
				</ion-col>
				<ion-col>
					<ion-button (click)="reset()" [disabled]="submitting" color="secondary" expand="block">{{
						'common.back' | translate
					}}</ion-button>
				</ion-col>
			</ion-row>
		</div>
	}

	@if (screen === FeedbackScreen.DONE) {
		<div class="fb-screen fb-active">
			<div class="fb-emoji">✅</div>
			<p class="fb-title">{{ 'feedbackWidget.doneTitle' | translate }}</p>
			<p class="fb-copy">{{ 'feedbackWidget.doneMessage' | translate }}</p>
		</div>
	}
</div>
